import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { ExpenseService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { Expense } from '../../models'

const log = new Logger('ExpenseDetailResolver')
@Injectable({ providedIn: 'root' })
export class ExpenseDetailResolver implements Resolve<Observable<Expense>> {
  constructor(private resService: ExpenseService, private router: Router) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let rid = route.params['eid']
    
    return this.resService.getDetail(rid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/expense']))
    )
  }
}
